module.exports = __webpack_public_path__ + "img/unread_ticks.adc207ee.svg";